export enum ProductMetaCode {
  // 한정
  LIMITED = 'LIMITED',

  // 품절 임박
  LOW_STOCK = 'LOW_STOCK',

  // 펀딩
  FUNDING = 'FUNDING',
}
